import { render, staticRenderFns } from "./AddCollectNode.vue?vue&type=template&id=4a2b8dc0&scoped=true"
import script from "./AddCollectNode.vue?vue&type=script&lang=js"
export * from "./AddCollectNode.vue?vue&type=script&lang=js"
import style0 from "./AddCollectNode.vue?vue&type=style&index=0&id=4a2b8dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b8dc0",
  null
  
)

export default component.exports